import { Component, Input, OnInit } from '@angular/core';
import { DefaultUploadFileTypeAccept } from '@app/shared/constants';

@Component({
  selector: 'app-button-add-midia',
  templateUrl: './button-add-midia.component.html',
  styleUrls: ['./button-add-midia.component.sass'],
})
export class ButtonAddMidiaComponent {
  @Input() label: string;
  acceptFiles = DefaultUploadFileTypeAccept;
}
